import axios from "../../../utils/authAxios";
import { LicenseTypeInfo } from "../../../modules/Utilities/ConfigureAgreement/LicenseType/types";

const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getLicenseType = async () => {
  const { data } = await axios.get(`${api_base_url}/License`);
  return data;
};

// Insert New LicenseType
export const addLicenseType = async (newLicenseType) => {
  const { data } = await axios.post(`${api_base_url}/License`, {
    ...newLicenseType,
  });
  return data;
};

// Update LicenseType
export const updateLicenseType = async (updatedLicenseData) => {
  const data = await axios.put(
    `${api_base_url}/License/${updatedLicenseData?.licenseTypeId}`,
    updatedLicenseData
  );
  return data;
};

export const deleteLicenseType = async (ids) => {
  await axios.delete(`${api_base_url}/License/`, {
    data: ids,
  });
};
